import Color from '../Color.js';
import { clip_rgb } from '../utils/index.js';
var pow = Math.pow,
  sqrt = Math.sqrt,
  PI = Math.PI,
  cos = Math.cos,
  sin = Math.sin,
  atan2 = Math.atan2;
export default (function (colors) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'lrgb';
  var weights = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var l = colors.length;
  if (!weights) weights = Array.from(new Array(l)).map(function () {
    return 1;
  });
  // normalize weights
  var k = l / weights.reduce(function (a, b) {
    return a + b;
  });
  weights.forEach(function (w, i) {
    weights[i] *= k;
  });
  // convert colors to Color objects
  colors = colors.map(function (c) {
    return new Color(c);
  });
  if (mode === 'lrgb') {
    return _average_lrgb(colors, weights);
  }
  var first = colors.shift();
  var xyz = first.get(mode);
  var cnt = [];
  var dx = 0;
  var dy = 0;
  // initial color
  for (var i = 0; i < xyz.length; i++) {
    xyz[i] = (xyz[i] || 0) * weights[0];
    cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
    if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
      var A = xyz[i] / 180 * PI;
      dx += cos(A) * weights[0];
      dy += sin(A) * weights[0];
    }
  }
  var alpha = first.alpha() * weights[0];
  colors.forEach(function (c, ci) {
    var xyz2 = c.get(mode);
    alpha += c.alpha() * weights[ci + 1];
    for (var _i = 0; _i < xyz.length; _i++) {
      if (!isNaN(xyz2[_i])) {
        cnt[_i] += weights[ci + 1];
        if (mode.charAt(_i) === 'h') {
          var _A = xyz2[_i] / 180 * PI;
          dx += cos(_A) * weights[ci + 1];
          dy += sin(_A) * weights[ci + 1];
        } else {
          xyz[_i] += xyz2[_i] * weights[ci + 1];
        }
      }
    }
  });
  for (var _i2 = 0; _i2 < xyz.length; _i2++) {
    if (mode.charAt(_i2) === 'h') {
      var _A2 = atan2(dy / cnt[_i2], dx / cnt[_i2]) / PI * 180;
      while (_A2 < 0) _A2 += 360;
      while (_A2 >= 360) _A2 -= 360;
      xyz[_i2] = _A2;
    } else {
      xyz[_i2] = xyz[_i2] / cnt[_i2];
    }
  }
  alpha /= l;
  return new Color(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
});
var _average_lrgb = function _average_lrgb(colors, weights) {
  var l = colors.length;
  var xyz = [0, 0, 0, 0];
  for (var i = 0; i < colors.length; i++) {
    var col = colors[i];
    var f = weights[i] / l;
    var rgb = col._rgb;
    xyz[0] += pow(rgb[0], 2) * f;
    xyz[1] += pow(rgb[1], 2) * f;
    xyz[2] += pow(rgb[2], 2) * f;
    xyz[3] += rgb[3] * f;
  }
  xyz[0] = sqrt(xyz[0]);
  xyz[1] = sqrt(xyz[1]);
  xyz[2] = sqrt(xyz[2]);
  if (xyz[3] > 0.9999999) xyz[3] = 1;
  return new Color(clip_rgb(xyz));
};